import React from "react";
import Link from "gatsby-link";

import { Jumbotron, Grid, Row, Col, Image, Button } from "react-bootstrap";
import AltHeader from "../../components/alt-header.js";
import Header from "../../components/header.js";
import UpNext from "../../components/up-next.js";
import Layout from "../../components/Layout.js";
import JobHeader from "../../components/job-header.js";
import prepHero from "../../img/prep-hero.jpg";
import demo1 from "../../img/prep-plus/demo1.png";
import demo2 from "../../img/prep-plus/demo2.png";
import ybs1 from "../../img/prep-plus/ybs1.png";
import ybs2 from "../../img/prep-plus/ybs2.png";
import lbg from "../../img/prep-plus/lbg.png";
import ipsos from "../../img/prep-plus/ipsos.png";
import hsbc1 from "../../img/prep-plus/hsbc1.png";
import hsbc2 from "../../img/prep-plus/hsbc2.png";
import ba from "../../img/prep-plus/ba.png";
import smokinCard from "../../img/nas.jpg";
import superdrugCard from "../../img/superdrug-mobile-card.jpg";
const CappfinityPage = () => (
  <Layout>
    <JobHeader
      image={prepHero}
      title="Preparation Plus"
      subtitle="Digital pre-skilling, reskilling, and upskilling"
      text="Design / Development / Leadership"
    />

    <Row className="show-grid side-padding intro">
      <Col xs={12} sm={10} smOffset={2} md={12} mdOffset={2}>
        <h2>My Role</h2>
        <p className="job-text">
            My role at Cappfinity involves leading a team of front-end engineers to design and build candidate preparation sites. We create interactive portals using React that provide comprehensive resources to help candidates succeed in their job applications. These sites include detailed guides, practice materials, and interactive modules covering various aspects of the hiring process - from assessment centers and interviews to situational judgment tests and technical evaluations. We have created over 50 sites - below is a selection of just some of the sites that I personally had a hand in designing and building.
        </p>
      </Col>
    </Row>

    <Row className="show-grid">
      <Col xs={12} md={12}>
        <Image src={demo1} />
      </Col>
    </Row>

    <Row className="show-grid">
      <Col xs={12} md={12}>
        <Image src={demo2} />
      </Col>
    </Row>

    <Row className="show-grid">
      <Col xs={12} md={12}>
        <Image src={ybs1} />
      </Col>
    </Row>

    <Row className="show-grid">
      <Col xs={12} md={12}>
        <Image src={ybs2} />
      </Col>
    </Row>

    <Row className="show-grid">
      <Col xs={12} md={12}>
        <Image src={lbg} />
      </Col>
    </Row>

    <Row className="show-grid">
      <Col xs={12} md={12}>
        <Image src={ipsos} />
      </Col>
    </Row>

    <Row className="show-grid">
      <Col xs={12} md={12}>
        <Image src={hsbc1} />
      </Col>
    </Row>

    <Row className="show-grid">
      <Col xs={12} md={12}>
        <Image src={hsbc2} />
      </Col>
    </Row>

    <Row className="show-grid">
      <Col xs={12} md={12}>
        <Image src={ba} />
      </Col>
    </Row>

    <UpNext
      image1={smokinCard}
      title1="Smokin Mirrors"
      text1="Transforming hair brands from root to tip"
      url1="/smokin-mirrors/"
      image2={superdrugCard}
      title2="Superdrug Mobile"
      text2="Creating a mobile brand from scratch"
      url2="/superdrug-mobile/"
      image3="/img/spread-co-card.jpg"
      title3="Spread Co"
      text3="A financial spread betting company"
      url3="/spread-co/"
    />
  </Layout>
);

export default CappfinityPage;
